import { useField, useFormikContext } from 'formik';
import { type FC, type WheelEvent } from 'react';

import { ODSNumberField } from '../../InputFields';

interface FormikNumberFieldProps {
  name: string;
  label: string;
  placeholder?: string;
  disabled?: boolean | string;
  onWheel?: (event: WheelEvent<HTMLInputElement>) => void;
}

export const FormikNumberField: FC<FormikNumberFieldProps> = ({
  name,
  label,
  placeholder = '',
  disabled = false,
  onWheel,
}) => {
  const [field, meta] = useField(name);
  const { values } = useFormikContext<Record<string, unknown>>();
  const isDisabled = typeof disabled === 'string' ? !values[disabled] : disabled;

  return (
    <ODSNumberField
      id={field.name}
      name={field.name}
      value={(field.value ?? '') as string | number}
      onChange={field.onChange}
      onBlur={field.onBlur}
      label={label}
      placeholder={placeholder}
      disabled={isDisabled}
      {...(onWheel && { onWheel })}
      {...(meta.touched && { helperText: meta.error })}
    />
  );
};
